// English UI strings. Must mirror da.ts key-for-key (enforced by the type).
import { SITE_NAME } from '@/site.config'
import type { Messages } from './messages'

export const en: Messages = {
  languageName: 'English',
  nav: {
    skipLink:   'Skip to content',
    openMenu:   'Open menu',
    closeMenu:  'Close menu',
    logoLabel:  `${SITE_NAME}, to the front page`,
    primary:    'Primary navigation',
    mobile:     'Mobile navigation',
    footer:     'Footer navigation',
    language:   'Language',
    switchTo:   'Switch to English',
    cta:        'Contact',
  },

  footer: {
    copyright: (year: number) => `© ${year} ${SITE_NAME}`,
  },

  hero: {
    headline:    'Welcome',
    subheadline: 'Edit this text in the CMS under Pages → home → Hero.',
    ctaLabel:    'Get in touch',
  },

  common: {
    loading:     'Loading…',
    error:       'The content could not be loaded right now.',
    notFound:    '404',
    notFoundMsg: 'This page does not exist.',
    toFrontpage: 'To the front page',
    lastUpdated: 'Last updated',
    copied:      'Email copied!',
  },

  app: {
    materialsTitle: 'Materials',
    materialsLede:  'Pocket cards, guides and member information from FS K&T.',
    allCategories:  'All',
    noMaterials:    'No materials in this category yet.',
    featured:       'Featured',
    seeAll:         'See all materials',
    attachments:    'Files',
    download:       'Download',
    reviewed:       'Clinically reviewed',
    backToList:     'All materials',
    eventsTitle:    'Events',
    noEvents:       'No upcoming events.',
    nextEvent:      'Next event',
    signup:         'Sign up',
    news:           'News from the board',
  },

  pageTitles: {
    notFound: 'Page not found',
  },

  errorPage: {
    title: (status: number) => `Error ${status}`,
    heading: 'Something went wrong',
    body: 'The page could not be shown right now. Please try again shortly.',
  },
}
